<template>
  <ZoomOneEduPlanDetail
    :class="{ 'opc-modal-dialog': isModal }"
    :show-close="!isModal"
    v-bind="{
      visible,
      id,
      currencySymbol,
      enableDisplayZoomWorkFlow,
      enableDisplayZoomDrive,
      bizCategoryCode,
      largeMeetingCallback,
      fullListCallBack,
      enableDocsFeature,
      enableDisplayZoomTasksWithoutAccountCheck,
      showCampusScheduler,
      isEligibleAccount4CustomAvatarFeature,
      enableEduWorkspaceReservations,
      enableLargeMeeting3k5k
    }"
    @closed="handleCancel"
  >
    <template v-if="isModal" slot="back">
      <NavBack :backHandler="handleCancel" class="mb24" />
    </template>
    <p slot="footer" class="zone-detail-dialog__tips">
      *{{ $t('billing.zone.edu_details.tips', [20, $money(annualPriceNum * 20, { forceDiff: true })]) }}
    </p>
  </ZoomOneEduPlanDetail>
</template>

<script>
import { mapGetters } from 'vuex';

import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import { getCurrency, getCurrencySymbol } from "@/utils/currency";
import { plansof } from '@/utils/chain';
import { planTypes } from '@/common/constants';
import { ZOOM_MEETING_SUB_TYPES } from '../common/utils';
import NavBack from '@/components/nav-back.vue';

export default {
  name: 'ZoomOneEduSchoolCampsDetail',
  mixins: [ConfirmComponent],
  components: { NavBack },
  props: {
    largeMeetingCb: Function,
  },
  data() {
    return {
      visible: false,
      id: 'school',
      bizCategoryCode: ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP,
      currencySymbol: getCurrencySymbol(getCurrency()),
      enableDocsFeature: window.newBillingConfig.enableDocsFeature,
      enableLargeMeeting3k5k: window.newBillingConfig.enableLargeMeeting3k5k,
      showCampusScheduler: window.newBillingConfig.enableCampusScheduler,
      enableDisplayZoomTasksWithoutAccountCheck: window.newBillingConfig.enableDisplayZoomTasksWithoutAccountCheck,
      isEligibleAccount4CustomAvatarFeature: window.newBillingConfig.isEligibleAccount4CustomAvatarFeature,
      enableDisplayZoomWorkFlow: window.newBillingConfig.enableDisplayZoomWorkFlow,
      enableDisplayZoomDrive: window.newBillingConfig.enableDisplayZoomDrive,
      enableEduWorkspaceReservations: window.newBillingConfig.wsrVM4SchoolOnline,
    }
  },
  computed: {
    ...mapGetters(['planMapFlat']),
    isModal() {
      return this.$context?.is.modal;
    },
    annualPriceNum() {
      const eduAnnualPlan = plansof(this.planMapFlat)
        .type(planTypes.ZOOM_MEETING)
        .category(ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP)
        .annual()
        .get(0);
      return eduAnnualPlan?.amount;
    },
    largeMeetingCallback() {
      if (typeof this.largeMeetingCb == 'function') {
        return () => {
          this.largeMeetingCb()
          this.handleCancel()
        }
      }
      return null
    }
  },
  methods: {
    fullListCallBack() {
      this.handleSure()
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@/styles/modal.scss';
</style>
